import React, { useState } from "react";
import {
    Alert,
    Container,
    TextField,
    Button,
    Typography,
    Box,
    Snackbar,
} from "@mui/material";


const ChangePassword = () => {
    const [email, setEmail] = useState("");
    const [otp, setOtp] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [otpSent, setOtpSent] = useState(false);
    const [error, setError] = useState("");
    const [success, setSuccess] = useState("");

    // Simulate email existence check (replace with API call)
    const checkEmailExists = async (email) => {
        // Replace this with your API call to check if the email exists
        const validEmails = ["user@example.com", "test@example.com"];
        return validEmails.includes(email);
    };

    // Simulate OTP generation and sending (replace with API call)
    // const sendOtp = async (email) => {
    //     // Replace this with your API call to send OTP
    //     return Math.floor(100000 + Math.random() * 900000); // Generate a 6-digit OTP
    // };

    // Handle email submission to send OTP
    const handleSendOtp = async () => {
        if (!email) {
            setError("Please enter your email.");
            return;
        }

        const emailExists = await checkEmailExists(email);
        if (!emailExists) {
            setError("Email does not exist in our system.");
            return;
        }

        // const otp = await sendOtp(email);
        // console.log(otp)
        setOtpSent(true);
        setSuccess(`OTP sent to ${email}.`);
    };

    // Handle password change submission
    const handleChangePassword = async () => {
        if (!otp || !newPassword || !confirmPassword) {
            setError("Please fill all fields.");
            return;
        }

        if (newPassword !== confirmPassword) {
            setError("Passwords do not match.");
            return;
        }

        // Replace this with your API call to validate OTP and change password
        const isOtpValid = true; // Simulate OTP validation
        if (!isOtpValid) {
            setError("Invalid OTP.");
            return;
        }

        setSuccess("Password changed successfully!");
        setError("");
    };

    return (
        <Container maxWidth="sm">
            <Box mt={5}>
                <Typography variant="h4" align="center" gutterBottom>
                    Change Password
                </Typography>

                {/* Email Input */}
                <TextField
                    label="Email"
                    fullWidth
                    margin="normal"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    disabled={otpSent}
                />

                {/* Send OTP Button */}
                {!otpSent && (
                    <Button
                        variant="contained"
                        color="primary"
                        fullWidth
                        onClick={handleSendOtp}
                    >
                        Send OTP
                    </Button>
                )}

                {/* OTP Input */}
                {otpSent && (
                    <TextField
                        label="OTP"
                        fullWidth
                        margin="normal"
                        value={otp}
                        onChange={(e) => setOtp(e.target.value)}
                    />
                )}

                {/* New Password Input */}
                {otpSent && (
                    <TextField
                        label="New Password"
                        type="password"
                        fullWidth
                        margin="normal"
                        value={newPassword}
                        onChange={(e) => setNewPassword(e.target.value)}
                    />
                )}

                {/* Confirm Password Input */}
                {otpSent && (
                    <TextField
                        label="Confirm Password"
                        type="password"
                        fullWidth
                        margin="normal"
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                    />
                )}

                {/* Change Password Button */}
                {otpSent && (
                    <Button
                        variant="contained"
                        color="primary"
                        fullWidth
                        onClick={handleChangePassword}
                    >
                        Change Password
                    </Button>
                )}

                {/* Error and Success Messages */}
                {error && (
                    <Snackbar
                        open={!!error}
                        autoHideDuration={6000}
                        onClose={() => setError("")}
                    >
                        <Alert severity="error">{error}</Alert>
                    </Snackbar>
                )}
                {success && (
                    <Snackbar
                        open={!!success}
                        autoHideDuration={6000}
                        onClose={() => setSuccess("")}
                    >
                        <Alert severity="success">{success}</Alert>
                    </Snackbar>
                )}
            </Box>
        </Container>
    );
};

export default ChangePassword;